
//TO-DO: Passar estes métodos para a model-sagres
export class FiltrosPrestacaoContasLRFCI {
    ano: string
    tipoDeRelatorio: string
    periodo: string
    situacao: string

    constructor() {
        this.ano = ''
        this.tipoDeRelatorio = ''
        this.periodo = ''
        this.situacao = ''
    }

    limpar(): void {
        this.ano = ''
        this.tipoDeRelatorio = ''
        this.periodo = ''
        this.situacao = ''
    }

    toFormData(): FormData {
        const data = new FormData()
        if (this.ano)
            data.append("ano", this.ano)
        if (this.tipoDeRelatorio)
            data.append("tipoDeRelatorio", this.tipoDeRelatorio)
        if (this.periodo)
            data.append("periodo", this.periodo)
        if (this.situacao)
            data.append("situacao", this.situacao)
        return data
    }

    toQueryString(): string {
        let retorno = ''
        if (this.ano)
            retorno += '&ano=' + this.ano
        if (this.tipoDeRelatorio)
            retorno += '&tipoRelatorio=' + this.tipoDeRelatorio
        if (this.periodo)
            retorno += '&periodo=' + this.periodo
        if (this.situacao)
            retorno += '&situacao=' + this.situacao
        return retorno
    }
}